import React, { useContext, useEffect, useState } from "react"
import { JourneyContext } from "../context/journeyContext"
import { TpaContext } from "../context/tpaContext"
import { bookMedicalAppointmentGowelNext, bookMedicalAppointmentHealthAssure, bookMedicalAppointmentHealthIndia, bookMedicalAppointmentMdIndia, fetchTPADetails, saveApplication } from "../../services/apiservice"
import { DataLayerIntegration, findCurrentJourneyCode } from "../services/helperFunctions"
import { PageContext } from "../context/pageContext"
import { addDaysToCurrentDate, formatDatetoDDMMYYY, formatTime } from "../../shared/functions"
import { errorToastr, successToastr } from "../../services/error-handler"
import TpaModal from './tpaComponents/TpaModal'
import CustomTimePicker from "./tpaComponents/CustomTimePicker"

function BookTPASlot(props) {
  const [appointmentDetails, setAppointmentDetails] = useState({
    time: "11:00 AM",
    date: addDaysToCurrentDate(2),
  })
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const { tpaState, setTpaState,tpaStateSA } = useContext(TpaContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [errHour, setErrHour] = useState(false)
  const [errMinutes, setErrMinutes] = useState(false)

  useEffect(() => {
    // if tpa details are not present, fetch tpa details from db
    if (!tpaState.matchType && tpaState.medicalTests.length === 0) {
      const payload = {
        journeyId: journeyState.journeyId,
        option : "LA"
      }
      fetchTPADetails(payload)
        .then(res => {
          if (!res.data || !res.data.response){
            handleSkip()
            return;
          }
          if (res.data.response && Array.isArray(res.data.response) && res.data.response.length === 0){
            handleSkip()
            return;
          }
          const matchType = res?.data?.response?.matchType
          let tpa = res?.data?.response?.response
          if (matchType === "PARTIAL" || tpa.length > 1) { // skip page when match is partial or in case of multiple tpas
            handleSkip()
            return
          } else if ((matchType === "EXACT" || matchType === "NEW") && tpa.length === 1) {
            tpa = tpa[0]

            if (!["Health India","Health Assure","Gowelnext"].includes(tpa.tpaName)){
              handleSkip()
              return;
            }

            const medicalPFRS = tpa.medicalPFRS || []
            if (medicalPFRS.length > 0) {
              const tpaName = tpa.tpaName
              const medicalType = medicalPFRS[0]?.pfrGroup
              const medicalTests = medicalPFRS?.map(pfr => pfr?.pfrDesc || "")
              setTpaState(prev => {
                return {
                  ...prev,
                  medicalTests: [...medicalTests],
                  tpaName: tpaName,
                  medicalType: medicalType,
                  matchType: matchType,
                  skipPage: false,
                }
              })
            }else{
              handleSkip()
            }
          }else{
            handleSkip()
            return;
          }
        })
        .catch(err => console.info(err))
    }
    
  }, [])

  const handleSkip = () => {
    console.info("skipping la...")
    if (tpaStateSA.skipPage || (tpaStateSA.isSA === false)){
      props.setCurrentPageIndex(prev => prev + 1)
      props.setCurrentSectionIndex(0)
    }else{
      props.setCurrentSectionIndex(prev => prev + 1)
    }

    let sendPayload = {
      applicationData: journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: tpaStateSA.skipPage || (tpaStateSA.isSA === false) ? props.currentPageIndex + 1 : props.currentPageIndex,
        lastSection: tpaStateSA.skipPage || (tpaStateSA.isSA === false) ? 0 : props.currentSectionIndex + 1,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        lastPageCode: props.pageId,
        planOption: journeyState.planOption,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
      },
    }

    saveApplication(sendPayload)
      .then(res => {
        setJourneyState(prev => {
          return {
            ...prev,
            journeyData: [
              ...journeyState.journeyData,
              {
                pageId: props.pageId,
                pageData: pageState.pageData,
              },
            ],
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex,
            lastPageCode: props.pageId,
            lastSectionCode:
              props.sections[props.currentSectionIndex].sectionId,
            journeyCode: findCurrentJourneyCode(
              props.pageId,
              props.sections[props.currentSectionIndex].sectionId
            ),
          }
        })
      })
      .catch(err => console.log(err))
  }

  const handleNext = () => {
    if (errHour || errMinutes){
      errorToastr("Please select time between 07:00 AM and 08:00 PM")
      return;
    }
    if (!appointmentDetails.date){
      errorToastr("Please select appointment date")
      return;
    }
    const payload = {
      journeyId : journeyState.journeyId,
      option : "LA",
      prefferedDate : formatDatetoDDMMYYY(appointmentDetails.date),
      prefferedTime : formatTime(appointmentDetails.time)
    }
    let pr;
    switch(tpaState.tpaName){
      case "Health India":
        pr = bookMedicalAppointmentHealthIndia(payload)
        break;
      case "Health Assure":
        pr = bookMedicalAppointmentHealthAssure(payload)
        break;
      case "Gowelnext":
        pr = bookMedicalAppointmentGowelNext(payload)
        break;
      default:
        handleSkip()
        return;
    }
    pr.then((res) => {
      try{
        sessionStorage.setItem("medicalDataLayer",JSON.stringify({
          time: payload?.prefferedTime,
          date: payload?.prefferedDate
        }));
      }catch(e){
        console.info(e);
      }
      let formControlKey = "proceed"
      let journeyFormatData = props.applicationDataInJourneyFormat()
      DataLayerIntegration(journeyFormatData, "", "sectionBookSlot",formControlKey, journeyState)
      successToastr("Appointment Booked Successfully!")
      handleSkip() // works same as goToNexPage in this case
    }).catch((err) => {
      errorToastr("Failed in booking appointment!")
      console.log("Error booking appointment:", err);
      handleSkip() // works same as goToNexPage in this case
    })

  }

  const handleBlur = (e) => {
    const minDateStr = addDaysToCurrentDate(2)
    const maxDateStr = addDaysToCurrentDate(15)
    const selectedDateStr = e.target.value
    
    const minDate = new Date(minDateStr)
    const maxDate = new Date(maxDateStr)
    const selectedDate = new Date(selectedDateStr)

    if (selectedDate < minDate) {
      setAppointmentDetails(prev => {
        return {
          ...prev,
          date : minDateStr
        }
      })
    }else if (selectedDate > maxDate){
      setAppointmentDetails(prev => {
        return {
          ...prev,
          date : maxDateStr
        }
      })
    }
  }

  return (
    <>
      <div className="landing-page1-design">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="col-md-12">
                <div className="iselect-box-design">
                  <div className="heading-design">
                    <div className="iselect-padding left-side-head ckyc-w">
                      <h1 className="iselect-heading">Book Slot</h1>
                    </div>
                    <div className="app-quatation nri-mt-space hidden-desktop-screen">
                      <div className="application-design-number">
                        Application Number: {journeyState.applicationNo}
                      </div>
                    </div>
                  </div>
                  <div
                    className="iselect-padding"
                    style={{
                      paddingLeft: "15px",
                    }}
                  >
                    <div
                      style={{
                        paddingTop: "30px",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "20px",
                          fontWeight: "bold",
                          color: "#0088c3",
                        }}
                      >
                        Medical Test Name:
                        <span
                          style={{
                            color: "#aaa",
                            fontWeight: "normal",
                            marginLeft: "5px",
                          }}
                        >
                          {tpaState.medicalTests.join(", ")}
                        </span>
                      </p>
                      <p
                        style={{
                          fontSize: "20px",
                          fontWeight: "bold",
                          color: "#0088c3",
                        }}
                      >
                        Medicals Type:
                        <span
                          style={{
                            color: "#aaa",
                            fontWeight: "normal",
                            marginLeft: "5px",
                          }}
                        >
                          {tpaState.medicalType}
                        </span>
                      </p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "50px",
                      }}
                    >
                      <div>
                        <div>
                          <label
                            style={{
                              fontSize: "18px",
                              color: "#0088c3",
                              marginRight: "20px",
                            }}
                          >
                            Choose Date:
                          </label>
                          <input
                            style={{
                              width: "300px",
                              padding: "5px",
                              paddingLeft: "14px",
                            }}
                            type="date"
                            min={addDaysToCurrentDate(2)} // T + 2
                            max={addDaysToCurrentDate(15)} // T + 15
                            value={appointmentDetails.date}
                            onChange={e =>
                              setAppointmentDetails(prev => {
                                return {
                                  ...prev,
                                  date: e.target.value,
                                }
                              })
                            }
                            onBlur={handleBlur}
                            name=""
                            id=""
                          />
                        </div>
                        <div
                          className="choose-time-container"
                          style={{
                            marginTop: "20px",
                          }}
                        >
                          <label
                            style={{
                              fontSize: "18px",
                              color: "#0088c3",
                              marginRight: "20px",
                            }}
                          >
                            Choose Time:
                          </label>
                          <CustomTimePicker
                            appointmentDetails={appointmentDetails}
                            setAppointmentDetails={setAppointmentDetails}
                            errHour={errHour}
                            errMinutes={errMinutes}
                            setErrHour={setErrHour}
                            setErrMinutes={setErrMinutes}
                          />
                        </div>
                        {(errHour || errMinutes) && <p className="time-validation-err-text">Choose Time between 07:00 AM and 8:00 PM</p>}
                      </div>
                    </div>
                    <div
                      style={{
                        marginTop: "50px",
                      }}
                    >
                      <div className="iselect-mg-bottom">
                        <div className="col-md-12">
                          <div className="but-center text-center">
                            <div className="submit-btn cen">
                              <a
                                aria-hidden="true"
                                onClick={() => setIsModalOpen(true)}
                              >
                                Skip
                              </a>
                            </div>
                            <div
                              className="previous-btn cen"
                              onClick={() => handleNext()}
                              aria-hidden={true}
                            >
                              <a>
                                <button
                                  type="submit"
                                  style={{
                                    backgroundColor: "transparent",
                                    border: "none",
                                    color: "#fff",
                                  }}
                                >
                                  Next
                                </button>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TpaModal
        medicalType={tpaState.medicalType}
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        handleSkip={handleSkip}
      />
    </>
  )
}

export default BookTPASlot